// Classes
import BaseService from './base-service';

// Constants
import { API_BASE_PATH } from 'libs/utils/constants';

const PDF_ANNOTATE_ASSET_ENDPOINT = `${ API_BASE_PATH }/events/{{eventId}}/pdf/annotations/{{docId}}`;

export default class PdfService extends BaseService {
    async annotateAsset(eventId, docId, params) {
        const url = this.buildUrl(PDF_ANNOTATE_ASSET_ENDPOINT, { eventId, docId });

        return await this.post(url, params);
    }

}
